export default {"src":"/polygon/_next/static/media/hedera.74f0b8ab.svg","height":10,"width":10};